import React, { useState } from 'react'
import { Box, Breadcrumbs, Typography } from '@material-ui/core'

import CustomLink from './CustomLink'

export default function CustomBreadcrumbs(props) {
  /**
  |--------------------------------------------------
  | State
  |--------------------------------------------------
  */
  const [isMobile] = useState(window.screen.availWidth < 640 ? true : false)
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { breadcrumbs } = props
  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <Box mb={3} py={1}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs.map(bc => (
          <div key={bc.to} className={isMobile ? "text-xs" : ""}>
            {bc.to ? (
              <CustomLink to={bc.to}>{bc.label}</CustomLink>
            ) : (
                <Typography color="textPrimary">{bc.label}</Typography>
              )}
          </div>
        ))}
      </Breadcrumbs>
    </Box>
  )
}

/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
CustomBreadcrumbs.defaultProps = {
  breadcrumbs: []
}
